var _module_exports = "";;
var path = 'partsforsale/detail/detail.html';
window.angular.module('row52-views').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;